import(/* webpackMode: "eager" */ "/usr/src/src/app/[store]/page.jsx");
